import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { MethodSettingsProps } from "../shared";

export const PelletResuspensionReagent = ({
  twelve24TCInternalState,
  handleMethodSettingsChanged,
}: MethodSettingsProps) => {
  const hasError =
    twelve24TCInternalState.methodSettings.pelletResuspensionVol! > 0 &&
    twelve24TCInternalState.methodSettings.pelletResuspensionVol! < 501 &&
    twelve24TCInternalState.methodSettings.pelletResuspensionRGT === 0;
  return (
    <div style={{ display: "flex", alignItems: "center", marginTop: 15 }}>
      <FormControl variant="outlined" fullWidth error={hasError}>
        <InputLabel id="pellet-resuspension-label">
          Pellet Resuspension / TopUp Reagent
        </InputLabel>
        <Select
          fullWidth={true}
          labelId="pellet-resuspension-label"
          id="pellet-resuspension-select"
          value={twelve24TCInternalState.methodSettings.pelletResuspensionRGT}
          label="Pellet Resuspension / TopUp Reagent"
          size="small"
          onChange={(e) => {
            handleMethodSettingsChanged(
              "pelletResuspensionRGT",
              e.target.value as number,
            );
          }}
        >
          <MenuItem value={0}></MenuItem>
          <MenuItem value={1}>Media</MenuItem>
          {/* Value 2 skipped intentionally */}
          <MenuItem value={3}>PBS</MenuItem>
          <MenuItem value={4}>CryopreservationRGT</MenuItem>
          <MenuItem value={5}>DNA Shield</MenuItem>
        </Select>

        <FormHelperText>
          {hasError ? "Reagent must be selected to upload plates" : ""}
        </FormHelperText>
      </FormControl>
    </div>
  );
};
